import { Reveal } from './Reveal'

export function SectionIntro({
  align = 'left',
  eyebrow,
  description,
  id,
  title,
}) {
  const alignment = align === 'center' ? 'mx-auto text-center' : ''

  return (
    <Reveal className={alignment}>
      <p className={`eyebrow ${align === 'center' ? 'justify-center' : ''}`}>
        {eyebrow}
      </p>
      <h2
        className={`section-title ${align === 'center' ? 'mx-auto' : ''}`}
        id={id}
      >
        {title}
      </h2>
      {description ? (
        <p className={`lede mt-6 ${align === 'center' ? 'mx-auto' : ''}`}>
          {description}
        </p>
      ) : null}
    </Reveal>
  )
}
